<template>
  <div>
    <vx-card class="mt-base mb-5" :title="activityTitle">
      <p class="mb-5">
        An actor’s voice is their instrument, and in order to be understood an actor must pronounce
        words clearly. Articulation is an essential skill for actors to master. Here are some tongue
        twisters, tongue twisters are a good way to practice clear articulation.
      </p>

      <p class="mb-5"><strong>Step 1:</strong> Read the 10 tongue twisters below then read aloud</p>
      <p class="mb-5"><strong>Step 2:</strong> Start slowly and build up speed</p>
      <p class="mb-5"><strong>Step 3:</strong> Memorize them and repeat them.</p>

      <ol class="numbered-list ml-8">
        <li>High roller, low roller, lower roller.</li>
        <li>I need a box of biscuits, a box of mixed biscuits, and a biscuit mixer.</li>
        <li>He thrusts his fists against the posts and still insists he sees the ghosts.</li>
        <li>The jolly collie swallowed a lollipop.</li>
        <li>The sick sister's zither ceaseth; therefore she sufficeth us.</li>
        <li>Friday's Five Fresh Fish Specials.</li>
        <li>Imagine an imaginary menagerie manager imagining managing an imaginary menagerie.</li>
        <li>Twixt this and six thick thistle sticks.</li>
        <li>Red leather, yellow leather.</li>
        <li>She sells seashells by the seashore, and the shells she sells are seashells</li>
      </ol>

      <fileupload-button-immediate
        v-model="uploaded_files['uploaded_file_1']"
        :is-editable="isEditable"
        filetype="video"
        index="1"
        key="1"
      />

      <save-buttons :is-editable="isEditable" @save="save" />
    </vx-card>
  </div>
</template>

<script>
import methods from '@/views/WorkExperiences/components/activity_js/methods';
import computed from '@/views/WorkExperiences/components/activity_js/computed';
import inject from '@/views/WorkExperiences/components/activity_js/inject';
export default {
  data() {
    return {
      uploaded_files: {
        uploaded_file_1: '',
      },
    };
  },
  methods: methods,
  computed: computed,
  inject: inject,
  mounted() {
    if (typeof this.uploaded_files !== 'undefined') {
      for (let i = 1; i <= Object.keys(this.uploaded_files).length; i++) {
        if (typeof this.data['uploaded_file_' + i] !== 'undefined') {
          this.uploaded_files['uploaded_file_' + i] = this.data['uploaded_file_' + i];
        }
      }
    }
  },
};
</script>
